<template>
  <div class="iframeTypebot">
    <iframe
      ref="typebotIframe"
      :src="typebotUrl"
      height="100%"
      scrolling="true"
      width="100%"
      frameborder="0"
    />
  </div>
</template>

<script>
import Cookies from 'js-cookie';
export default {
  components: {},
  mixins: [],
  props: {},
  computed: {
    typebotUrl() {
      const typebotUrl = window.chatwootConfig.typebotUrl;
      const token = Cookies.get('cw_d_session_info');

      const encode = encodeURIComponent(
        token.replace('{', '').replace('}', '')
      );

      const baseUrl = `${typebotUrl}/signin?from=omni&token=${encode}`;

      return baseUrl;
    },
  },
};
</script>

<style lang="scss" scoped>
.iframeTypebot {
  height: 100%;
  width: 100%;
}
</style>
